const React = require('react')
const { useState, useEffect } = require('react')
const { useLocation } = require('react-router-dom')
const { Container, Col, Row } = require('reactstrap')
const { useBlockchainData } = require('@hooks')
const { useNetworkConfig } = require('@contexts')
const { LoadingSpinner } = require('@components')
const { TableHeader, TableFooter } = require('@components/table')
const { NFTMintsTable } = require('./table.nftMints')

require('@styles/pages/blocks/index.css')

const NFTMints = () => {
    const location = useLocation()
    const { network } = useNetworkConfig()
    const { getNftsLatestMints } = useBlockchainData(network.name)

    const params = new URLSearchParams(location.search)

    const [page, setPage] = useState(Number(params.get('p')) || 1)
    const [limit, setLimit] = useState(Number(params.get('ps')) || 25)
    const [nftMintsData, setNftMintsData] = useState()

    const [loading, setLoading] = useState(false)
    const [title, setTitle] = useState('')
    const [subtitle, setSubtitle] = useState('')
    const [totalPages, setTotalPages] = useState(0)

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const pageParam = Number(params.get('p'))
        const limitParam = Number(params.get('ps'))

        if (pageParam && pageParam > 0 && pageParam !== page) {
            setPage(pageParam)
        }

        if (limitParam && limitParam > 0 && limitParam !== limit) {
            setLimit(limitParam)
        }
    }, [location.search])

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)

            try {
                const [nftMintsResponse] = await Promise.all([getNftsLatestMints(page, limit)])

                if (nftMintsResponse) {
                    setNftMintsData(nftMintsResponse)

                    setTitle(
                        nftMintsResponse.totalItems > 100_000
                            ? 'More than 100,000 records found'
                            : `A total of ${nftMintsResponse.totalItems.toLocaleString()} record${
                                  nftMintsResponse.totalItems === 1 ? '' : 's'
                              } found`
                    )
                    setSubtitle(nftMintsResponse.totalItems > 1_000 ? 'Showing the last 1000 records' : undefined)
                    setTotalPages(nftMintsResponse.totalItems > 1_000 ? 1_000 / limit : nftMintsResponse.totalPages)
                }
            } catch (error) {
                console.error('Error fetching data:', error)
            } finally {
                setLoading(false)
            }
        }

        fetchData()
    }, [network, page, limit])

    return (
        <div className='page'>
            <Container>
                <Col>
                    <Row>
                        <div className='page-header'>
                            <text className='page-title'>NFT Latest Mints</text>
                            <div className='page-title-border' />
                        </div>
                    </Row>

                    <div className='box table-section' style={{ padding: '24px 24px 0' }}>
                        {loading ? (
                            <div
                                className='d-flex justify-content-center align-items-center'
                                style={{ height: '300px' }}
                            >
                                <LoadingSpinner />
                            </div>
                        ) : (
                            <>
                                <TableHeader
                                    title={title}
                                    subtitle={subtitle}
                                    page={page}
                                    limit={limit}
                                    totalPages={totalPages}
                                />
                                <NFTMintsTable data={nftMintsData?.items} />
                                <TableFooter
                                    limit={limit}
                                    setLimit={setLimit}
                                    page={page}
                                    setPage={setPage}
                                    totalPages={totalPages}
                                />
                            </>
                        )}
                    </div>
                </Col>
            </Container>
        </div>
    )
}

module.exports = NFTMints
